import is from '@sindresorhus/is';
import { formatDistance } from 'date-fns';
import { isValid } from 'date-fns/isValid';
import Maybe from 'true-myth/maybe';
import { z } from 'zod';

import type { Locale } from 'date-fns';

const oneDay = 1000 * 60 * 60 * 24;
const dateTime = z.string().datetime({ offset: true });

export const isValidDate = (date: string | null | undefined): date is string =>
    is.string(date) && isValid(new Date(date));

export const dateDistanceToNowAsText = (
    currentTimestamp: number,
    locale: Locale,
    dateStringFrom: string,
): Maybe<string> => {
    return dateTime
        .transform((date) =>
            Maybe.of(
                formatDistance(new Date(date), currentTimestamp, {
                    addSuffix: true,
                    locale,
                }),
            ),
        )
        .parse(dateStringFrom);
};

export const getTimeDeltaInDays = (date1: Date, date2: Date): number => {
    const deltaInTime = Math.abs(date2.getTime() - date1.getTime());

    return Math.floor(deltaInTime / oneDay);
};
